import { eShowTiFo, eTlfItemType } from "functions/api/enums";
import { IMosaicTocExpanded } from "./interface";

export const tocInitialState: IMosaicTocExpanded = {
  blocked: false,
  changed: false,
  hierarchyId: "",
  readOnly: true,
  receivedMessages: [],
  removedItems: [],
  saving: false,
  saveError: false,
  searchText: "",
  sendUpdate: false,
  showTypes: Object.values(eTlfItemType),
  showTiFo: eShowTiFo.ToC,
  tocItems: [],
  commentsFilter: "all",
  lastMinorVersionSavedAt: null,
  lastMajorVersionSavedAt: 0,
  tocRequestStatus: { requesting: false, error: false },
  showSaveAlert: false,
  tocIdFromMessage: undefined,
  showNeedRefresh: false,
};
